import { Component } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'app-auto-open-menu',
    templateUrl: './auto-open-menu.component.html',
    imports: [
        MatMenuModule
    ]
})
export class AutoOpenMenuComponent {
    timedOutCloser: number;

    mouseEnter(trigger: any) {
        if (this.timedOutCloser) {
            clearTimeout(this.timedOutCloser);
        }
        trigger.openMenu();
    }

    mouseLeave(trigger: any) {
        this.timedOutCloser = setTimeout(() => {
            trigger.closeMenu();
        }, 100);
    }
}
